import { Button } from '@mui/material';
import { useOrganization } from '../hooks/useOrganization';
import { useAuth } from '../hooks/useAuth';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { successToastConfig, dangerToastConfig } from '../utils/data';
import { InputTextField } from '../components/Input/InputTextField';

const Settings = () => {
  const { user } = useAuth();
  const { updateMarkup, accountSelected, getAccountsList, getAccounts} = useOrganization();
  const [markUpValue, setMarkUpValue] = useState(1.5);

  useEffect(() => {
      if(accountSelected) {
        const selectedAccount = getAccountsList.find(account => account._id === accountSelected);
        setMarkUpValue(selectedAccount.settings.markUp);
      }
    }, [accountSelected, getAccountsList]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    let res = await updateMarkup(accountSelected, markUpValue);
    if(res.status === 200){
        getAccounts(user.accountId);
        toast('Settings updated successfully', successToastConfig);
    } else {
        toast('Something went wrong. Please try again', dangerToastConfig);
    }
  }

  const handleMarkUpChange = (value) => {
    setMarkUpValue(value);
  }

  
  return (
    <>
      {accountSelected ? (
        <div className="main-content page-dashboard" style={{ padding: '24px' }}>
          <div
            style={{
              width: '100%',
              background: 'var(--bg-main)',
              border: '1px solid var(--border-color)',
              borderRadius: 20,
              padding: 28,
              boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
            }}
          >
            <form onSubmit={handleSubmit}>
              <div
                style={{
                  background: 'var(--bg-panel)',
                  border: '1px solid var(--border-color)',
                  borderRadius: 16,
                  padding: 22,
                }}
              >
                <div style={{ maxWidth: 360 }}>
                  <InputTextField
                    title="Markup"
                    value={markUpValue}
                    onChange={handleMarkUpChange}
                    inputMode="decimal"
                    allowPattern={/^\d*\.?\d*$/}
                    placeholder='Enter markup value'
                  />
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 22 }}>
                <Button variant='contained' color='primary' type="submit">
                  Save
                </Button>
              </div>
            </form>
          </div>
        </div>
      ) : (
          <div className="main-content page-dashboard">
            <p style={{textAlign: 'center', marginTop: 50, fontSize: '18px', fontWeight: 'bold'}}>Please select an account to view the settings.</p>
          </div>
      )} 
    </>
  );
};

export default Settings; 
